import { render, staticRenderFns } from "./couponListCompont.vue?vue&type=template&id=ab415a3e&scoped=true"
import script from "./couponListCompont.vue?vue&type=script&lang=js"
export * from "./couponListCompont.vue?vue&type=script&lang=js"
import style0 from "./couponListCompont.vue?vue&type=style&index=0&id=ab415a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab415a3e",
  null
  
)

export default component.exports